import LoaderPage from 'components/ui/feedback/LoaderPage'
import { lazy } from 'react'
import { Route, RouteProps, Routes } from 'react-router-dom'

const FactorManagement = lazy(() => import('pages/factorManagement/factorIndex'))

const FactorRoutes: React.FunctionComponent<RouteProps> = () => {
  return (
    <Routes>
      <Route path="/" element={<LoaderPage content={<FactorManagement />} />} />
    </Routes>
  )
}

export default FactorRoutes
